<ui-dialog
    [open]="open"
    [isCloseable]="true"
    [header]="headerText"
    (primaryButtonPressed)="mode === 'add' ? onAdd(form) : onEdit(form)"
    [primaryButtonLabel]="(mode === 'add' ? 'add' : 'save') | appTranslate"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    [secondaryButtonType]="'ghost'"
    (closing)="onClose()"
    [form]="form"
>
    <form #form="ngForm" autocomplete="off">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{
                    'applicant-tracker.components.auto-archiving-questions.autoArchivingQuestions' | appTranslate
                }}</mat-label>

                <input
                    matInput
                    type="text"
                    required
                    name="question"
                    [(ngModel)]="question.question"
                    #autoArchivingQuestion="ngModel"
                />
                <mat-error *ngIf="autoArchivingQuestion.invalid">{{
                    autoArchivingQuestion.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-8">
                <mat-label appRemoveAriaOwns>{{
                    'applicant-tracker.components.auto-archiving-questions.visibility' | appTranslate
                }}</mat-label>
                <mat-select
                    type="text"
                    required
                    name="visibility"
                    [(ngModel)]="question.accessLevelLabel"
                    #visibility="ngModel"
                >
                    <mat-option *ngFor="let accessLevel of accessLevels" [value]="accessLevel">
                        {{ accessLevel | translate }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="visibility.invalid">{{ visibility.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </form>
</ui-dialog>
